import { getComponentData } from '@backstage/core-plugin-api';
import { createCollector } from '../extensions/traversal.esm.js';

const pluginCollector = createCollector(
  () => /* @__PURE__ */ new Set(),
  (acc, node) => {
    const plugin = getComponentData(node, "core.plugin");
    if (plugin) {
      acc.add(plugin);
    }
  }
);

export { pluginCollector };
//# sourceMappingURL=collectors.esm.js.map
